import React, {useEffect, useId, useRef} from 'react';
import {useDispatch} from 'react-redux';

import {StickyPageLayout} from '@/components/Layout';
import PopupResponsive from '@/components/Popup/PopupResponsive';
import useOneModalOnPageAtATime from '@/components/Popup/useOneModalOnPageAtATime';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import useOnFocusChange from '@/hooks/useOnFocusChange';
import amplitudeNotificationTracking from '@/services/analytics/amplitude/amplitudeNotificationTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import notificationPermissionService from '@/services/pushNotification/notificationPermissionService';
import {hideModalAction} from '@/state/slices/modalSlice';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import ResetNotificationPermissionsModalContent from './ResetNotificationPermissionsModalContent';

const ResetNotificationPermissionsModal = ({modalType}) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);
    const headerId = useId();

    const isMobile = useIsMobileLayout();

    useOneModalOnPageAtATime();

    useEffect(() => {
        googleAnalyticsService.trackPushNotificationsSystemSettingsStepsViewed();
        amplitudeNotificationTracking.trackPushNotificationsSystemSettingsStepsViewed();
    }, []);

    useOnFocusChange(async () => {
        const isNotificationGranted = await notificationPermissionService.checkIfNotificationIsGranted();
        const isNotificationDefault = await notificationPermissionService.checkIfNotificationIsDefault();

        if (isNotificationGranted || isNotificationDefault) {
            onClose();
        }
    });

    const onClose = () => {
        dispatch(hideModalAction(modalType));
    };

    return (
        <PopupResponsive
            className='flex ml:max-w-[458px] ml:rounded-3xl ml:p-8 ml:text-center'
            overlayRef={popupRef}
            onClose={onClose}
            isCloseVisible
            aria-labelledby={headerId}
        >
            {isMobile && (
                <WarningBannersTop
                    source={WARNING_BANNER_SOURCE_TYPES.ENABLE_NOTIFICATION_POPUP}
                    containerRef={popupRef}
                />
            )}
            {isMobile ? (
                <StickyPageLayout
                    className='items-center pt-safe'
                    contentClassName='flex flex-1 flex-col items-center'
                    footer={<ResetNotificationPermissionsModalContent.SaveButton onClick={onClose} />}
                >
                    <ResetNotificationPermissionsModalContent headerId={headerId} />
                    <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.ENABLE_NOTIFICATION_POPUP} />
                </StickyPageLayout>
            ) : (
                <ResetNotificationPermissionsModalContent headerId={headerId}>
                    <ResetNotificationPermissionsModalContent.SaveButton
                        className='mt-8'
                        headerId={headerId}
                        onClick={onClose}
                    />
                </ResetNotificationPermissionsModalContent>
            )}
        </PopupResponsive>
    );
};

export default ResetNotificationPermissionsModal;
